import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { API_URL } from "@/shared"
import { showNotification } from "@mantine/notifications"

export const useEvents = () => {
  return useQuery({
    queryKey: ["medical-education-events"],
    queryFn: async () => {
      try {
        const response = await axios.get(`${API_URL}/medical-education/events`)
        return response.data.data
      } catch (err) {
        console.error("Error getting events", err)
        showNotification({ title: "Error al obtener eventos", message: "No se pudieron cargar los eventos. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    }
  })
}

export const useCreateEvent = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (eventData: any) => {
      try {
        const response = await axios.post(`${API_URL}/medical-education/events`, eventData)
        showNotification({ title: "Evento agregado", message: "El evento ha sido agregado exitosamente.", color: "green" })
        return response.data.data
      } catch (err) {
        console.error("Error creating event", err)
        showNotification({ title: "Error al agregar evento", message: "No se pudo agregar el evento. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["medical-education-events"] })
    }
  })
}

export const useUpdateEvent = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, eventData }: { id: string; eventData: any }) => {
      try {
        const response = await axios.put(`${API_URL}/medical-education/events/${id}`, eventData)
        showNotification({ title: "Evento actualizado", message: "El evento ha sido actualizado exitosamente.", color: "green" })
        return response.data.data
      } catch (err) {
        console.error("Error updating event", err)
        showNotification({ title: "Error al actualizar evento", message: "No se pudo actualizar el evento. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["medical-education-events"] })
    }
  })
}

export const useDeleteEvent = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      try {
        const response = await axios.delete(`${API_URL}/medical-education/events/${id}`)
        showNotification({ title: "Evento eliminado", message: "El evento ha sido eliminado exitosamente.", color: "green" })
        return response.data
      } catch (err) {
        console.error("Error deleting event", err)
        showNotification({ title: "Error al eliminar evento", message: "No se pudo eliminar el evento. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["medical-education-events"] })
    }
  })
}
